import Head from "next/head";
import { wrapper } from "@/redux/Store";

import PrivacyPolicy from "@/containers/StaticPages/Policy";
import { renderMetaData } from "@/utils";
const PrivacyPolicyPage = () => {
  const metaData = {
    title: "Shyft privacy policy",
    description: "Shyft privacy policy",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <PrivacyPolicy />
      </main>
    </>
  );
};

export default PrivacyPolicyPage;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 15, // revalidate in 15 days
  };
});
